export default class NotificationLevel {
    static get Info () { return 1 }
    static get Warning () { return 2 }
    static get Error () { return 3 }
}
